// @flow
import createMaybeTransform from 'app/common/react/components/closeup/utils/createMaybeTransform';
import getPeople from 'app/common/react/components/closeup/utils/getPeople';
import type {
  HasArticle,
  HasRichMetadata,
  MaybeAToMaybeAB,
} from 'app/common/react/components/closeup/utils/types';

type ToMaybeHasArticle = MaybeAToMaybeAB<HasRichMetadata, HasArticle>;

const hasArticle: ToMaybeHasArticle = createMaybeTransform((props) => {
  const { richMetadata } = props,
    { article } = richMetadata,
    { name, description, authors, date_published: datePublished } = article || {};
  return name
    ? {
        ...props,
        article: {
          name,
          description,
          authors: getPeople(authors),
          datePublished: (datePublished && new Date(datePublished)) || undefined,
        },
      }
    : null;
});

export default hasArticle;
